module.exports = __webpack_public_path__ + "static/media/fb-icon.a42fce32.svg";